"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_odometerjs_1 = __importDefault(require("react-odometerjs"));
var useMoneyFormatter_1 = require("../../../../../hooks/useMoneyFormatter");
var Amount = function (_a) {
    var amount = _a.amount, currency = _a.currency, id = _a.id, type = _a.type, featureLengthType = _a.featureLengthType;
    var _b = (0, react_1.useState)(0), currentAmount = _b[0], setCurrentAmount = _b[1];
    var _c = (0, react_1.useState)(true), firstTime = _c[0], setFirstTime = _c[1];
    var _d = (0, useMoneyFormatter_1.useMoneyFormatter)(), moneyFormat = _d.moneyFormat, getCurrencySymbol = _d.getCurrencySymbol;
    (0, react_1.useEffect)(function () {
        setCurrentAmount(amount);
        var timeout = setTimeout(function () { return setFirstTime(false); }, 200);
        return function () {
            clearTimeout(timeout);
            timeout = null;
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (!firstTime) {
            setCurrentAmount(amount);
        }
    }, [amount]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ id: "amount-".concat(id), className: "amount amount--".concat(type.toLowerCase(), " ").concat(featureLengthType, " ").concat(firstTime ? "first-time" : "") }, { children: [(0, jsx_runtime_1.jsx)(react_odometerjs_1.default, { format: "(,ddd).dd", value: moneyFormat(currentAmount), className: "amount__item ".concat(type) }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "amount__item--currency" }, { children: getCurrencySymbol(currency) }))] }), "amount-".concat(id)));
};
var updateCallback = function (prevProps, nextProps) {
    return prevProps.amount === nextProps.amount && prevProps.isPlain === nextProps.isPlain;
};
exports.default = react_1.default.memo(Amount, updateCallback);
